import { useMutation, useQueryClient } from '@tanstack/react-query';

import ApiCart from '@Api/Cart';
import useCartKeys from './useCartKeys';

import type { CartData } from '@Types/Cart';

export const useRemovePromocode = () => {
  const queryClient = useQueryClient();
  const keys = useCartKeys();

  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      const res = await ApiCart.sendPromocode({
        'CouponForm[code]': '',
        'CouponForm[paymentTypeId]': '',
      });
      return res;
    },
    onSuccess: (NewCart) => {
      queryClient.setQueriesData({ queryKey: keys }, (prev: CartData) => {
        return {
          ...prev,
          ...NewCart,
        };
      });
    },
  });

  return {
    removePromocode: mutate,
    isPending,
  };
};

export default useRemovePromocode;
